<div class="content">
    <h2 class="page-title">{{ "GENERAL.CALENDAR" | translate }}</h2>
    <p><strong>PRÓXIMOS CURSOS NACIONAIS DE ARBITRAGEM</strong></p>

    <p>
        A partir de 2019, os Cursos Nacionais de Arbitragem passam a ter duração
        de dois dias, normalmente realizados aos sábados e domingos. O horário
        de início no primeiro dia é às 9h00, com término previsto para as 17h00
        do domingo.
    </p>

    <p>
        Não existe pré-requisito para participar dos cursos. Basta o
        participante ter interesse em arbitragem de tênis. Trata-se de um curso
        básico de arbitragem de tênis, com sessões teóricas em que o
        participante recebe informações sobre Regras de Tênis e Beach Tênis,
        Código de Conduta, Procedimentos para Jogos sem Juiz de Cadeira, Código
        de Oficiais, etc…
    </p>

    <p>
        O módulo com os Procedimentos para Juízes de Linha não será incluído em
        todos os cursos, sendo que, quando confirmado em algum final de semana,
        teremos o curso de 6ª a domingo, como vinha sendo feito nos últimos
        anos.
    </p>

    <p>
        No momento, entendemos que não há necessidade de formação de novas
        turmas de juízes de linha. Porém, havendo interesse de alguma Federação,
        estaremos confirmando esse modulo e conduzindo o curso no formato
        anterior.
    </p>

    <p>
        Todos os participantes recebem Certificado de Participação desde que
        atenda ao curso por completo. A participação no curso não garante a
        participação dos novos árbitros em nenhum torneio supervisionado pela
        CBT. Nosso objetivo é capacitar os interessados para que possam começar
        a atuar em torneios de tênis em suas regiões. Mais detalhes sobre esse
        processo serão tratados durante os cursos.
    </p>

    <p>
        Desde 2015, o módulo com os Procedimentos para Juízes de Cadeira são
        ministrados de forma separada, sendo dedicado um final de semana apenas
        para este assunto. Esse modulo será conduzido para árbitros que já
        tenham alguma experiência na posição e será confirmado juntamente com
        algum evento onde os participantes poderão atuar como juízes de cadeira
        nos jogos e então serem avaliados. As datas desses workshops, quando
        confirmadas, terão a observação sobre o módulo para juízes de cadeira e
        os convidados serão comunicados individualmente. Esse módulo não é um
        módulo aberto como os demais.
    </p>

    <p>
        Os interessados deverão preencher o formulário de inscrição, disponível
        no link abaixo. Após preencher o formulário online, solicitamos efetuar
        o deposito na conta indicada para a Confederação Brasileira de Tênis e
        enviar por e-mail para kelly.ferreira@cbtenis.com.br.
    </p>

    <p>
        Apenas o preenchimento do formulário não confirma sua inscrição no curso
        escolhido.
    </p>

    <p>
        O número mínimo de inscritos para realização do curso é de 15 pessoas. A
        CBT não recomenda a compra antecipada de passagens e/ou reservas em
        hotel até que seja confirmada a realização do curso. A confirmação ou
        não da realização do curso será feita no dia seguinte ao término das
        inscrições.
    </p>

    <p>
        <strong
            ><a
                href="http://cbt-tenis.com.br/arbitragem.php?cod=5"
                target="_blank"
                rel="noopener noreferrer"
                >Clique aqui e preencha a ficha de inscrição</a
            ></strong
        >
    </p>
</div>
